import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import ApiEndpoints from "./commonComponents/ApiEndpoints";

const EditQueryModal = ({
  show,
  handleClose,
  selectedQuery,
  onUpdate,
}) => {
  const [updatedQuery, setUpdatedQuery] = useState({
    title: "",
    category: "",
    priority: "",
    description: "",
  });
  const categories = [
  'Technical Issue',
  'Billing Inquiry',
  'Account Problem',
  'Feature Request',
  'General Question',
  'Other'
]

  useEffect(() => {
    if (selectedQuery) {
      setUpdatedQuery({
        title: selectedQuery.title || "",
        category: selectedQuery.category || "",
        priority: selectedQuery.priority || "",
        description: selectedQuery.description || "",
      });
    }
  }, [selectedQuery]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setUpdatedQuery((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveChanges = async () => {
    try {
      const response = await ApiEndpoints.updateQuery(
        selectedQuery.id,
        updatedQuery
      );

      toast.success(
        response?.data?.message || "Query updated successfully"
      );

      onUpdate();
      handleClose();
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        "Something went wrong."
      );
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
    >
      <Modal.Header
        closeButton
        closeVariant="white"
        className="text-dark"
        style={{ backgroundColor: "#BDE0FE" }}
      >
        <Modal.Title>Edit Query</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Query Title</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={updatedQuery.title}
              onChange={handleInputChange}
              placeholder="Enter Query Title"
            />
          </Form.Group>

          <Form.Group className="mb-3">
  <Form.Label>Category</Form.Label>
  <Form.Select
    name="category"
    value={updatedQuery.category}
    onChange={handleInputChange}
  >
    <option value="">Select a category</option>
    {categories.map((cat, index) => (
      <option key={index} value={cat}>{cat}</option>
    ))}
  </Form.Select>
</Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Priority</Form.Label>
            <Form.Select
              name="priority"
              value={updatedQuery.priority}
              onChange={handleInputChange}
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
              <option value="critical">Critical</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="description"
              value={updatedQuery.description}
              onChange={handleInputChange}
              placeholder="Enter Query Description"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
        >
          Cancel
        </Button>

        <Button
          variant="success"
          onClick={handleSaveChanges}
        >
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditQueryModal;